var _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmallBreadcrumbChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "\\u276F",
    transform: "translate(6 17)",
    fill: "#575757",
    fontSize: 16,
    fontFamily: "ZapfDingbatsITC,'\\\\\\\\.Apple Symbols Fallback'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u276F"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3053",
    fill: "none",
    d: "M0 0h20v20H0z"
  })));
}
export default SvgIconSmallBreadcrumbChevron;